import { http } from '../../helpers';
import { updateCaseLabAction } from '../reducers/cases.reducer';

export function updateCase(payload) {
    return (dispatch) => {
        const relativeUrl = `/case-api/cases/${payload.id}`;
        http.put(relativeUrl, payload)
            .then((res) => {
                if (res.status === 200) {
                    dispatch(updateCaseLabAction(payload.id, payload.labId, payload.labName));
                }
            })
            .catch((error) => {
                console.warn(error);
            });
    };
}
